export const BASE_ERROR_MESSAGE =
  'Произошла ошибка. Пожалуйста, попробуйте позже'
